export default "__VITE_ASSET__BTwzx8id__"